import { useEffect } from 'react';
import { CountryCode } from '@dayetopia/library';
import moment from 'moment';
import { getDateLocale } from '@utils/date';

const useMomentLocale = (country: CountryCode | undefined) => {
  useEffect(() => {
    const locale = getDateLocale(country);
    moment.locale(locale);
  }, [country]);
};

export default useMomentLocale;
